var app = {
	header: {
		build: "Build",
		closeButton: "Fechar",
		copyrightLabel: "Direitos autorais",
		helpLabel: "Ajuda",
		legalNoticeLabel: "Aviso Legal",
		logoutButton: "Sair",
		menuLabel: "Menu",
		module: "Módulo",
		noUserDataLabel: "Nenhum dado de usuário disponível",
		notificationsLabel: "Notificações",
		privacyPolicyLabel: "Política de Privacidade",
		serviceAppLabel: "App de Serviço",
		settingsLabel: "Configurações",
		shopLabel: "Loja",
		smartFactorySuiteLabel: "Suite de Fábrica Inteligente",
		softwareInformation: "Informações do Software",
		userLabel: "Perfil",
		userProfileLinkText: "Perfil do Usuário",
		version: "Versão"
	}
};
var contentLoadingError = "O conteúdo não pôde ser carregado";
var dashboard = {
	cancel: {
		button: "Cancelar"
	},
	edit: {
		button: "Editar"
	},
	reset: {
		button: "Redefinir"
	},
	save: {
		button: "Salvar"
	},
	share: {
		button: "Compartilhar"
	}
};
var filter = {
	clear: "Redefinir filtros",
	clearAll: "Redefinir todos os filtros"
};
var locationMap = {
	locationLink: {
		label: "Para o local"
	}
};
var machineDiscontinuation = {
	linkText: "Saiba mais"
};
var notifications = {
	button: {
		loadMore: "Carregar mais"
	},
	date: {
		lastMonth: "Último mês",
		lastWeek: "Última semana",
		older: "Mais antigos",
		thisMonth: "Este mês",
		thisWeek: "Esta semana",
		today: "Hoje",
		yesterday: "Ontem"
	},
	error: {
		general: "Atualmente, não é possível exibir notificações. Por favor, tente novamente mais tarde.",
		unauthorized: "Por favor, faça login para ver as notificações"
	},
	info: {
		activateSettings: "Para receber notificações, por favor, ative-as nas configurações",
		noNotification: "Atualmente, não há mensagens para você."
	},
	title: "Notificações"
};
var results = {
	counter: {
		label: "resultados"
	}
};
var scrollToTop = {
	label: "Rolar para o topo"
};
var slider = {
	nextButton: {
		label: "Próximo Slide"
	},
	paginationBullet: {
		label: "Slide"
	},
	prevButton: {
		label: "Slide Anterior"
	}
};
var sorting = {
	ascending: "Ascendente",
	descending: "Descendente"
};
var userAccount = {
	address: {
		label: "Endereço postal"
	},
	email: {
		label: "E-mail"
	},
	language: {
		label: "Idioma",
		locale: "Localidade",
		select: "Selecionar idioma",
		settings: "Configurações de idioma"
	},
	loggedOut: {
		message: "Você não está logado"
	},
	login: {
		button: "Entrar"
	},
	name: {
		label: "Nome"
	},
	phone: {
		label: "Telefone"
	}
};
var widget = {
	filter: {
		machine: {
			filter: "Filtrar máquinas",
			label: "Máquinas",
			option: {
				all: "Todas as Máquinas"
			},
			select: "Selecionar máquina"
		},
		period: {
			label: "Período",
			option: {
				currentMonth: "Este mês",
				currentWeek: "Esta semana",
				lastMonth: "Último mês",
				lastWeek: "Última semana",
				today: "Hoje",
				yesterday: "Ontem"
			}
		}
	}
};
var widgetRegistry = {
	allWidgets: {
		label: "Meus widgets"
	},
	noDescriptionAvailable: "Descrição não disponível.",
	widget: {
		SampleMyMachines: {
			title: "Minhas Máquinas"
		},
		SampleMyServiceCalls: {
			title: "Chamadas de Serviço"
		},
		SampleMyTrackingList: {
			title: "Lista de Rastreamento"
		},
		SampleMyUserAccount: {
			title: "Meu perfil"
		},
		SampleOperationalStatesChart: {
			title: "Estados Operacionais"
		},
		SampleWidgetFilter: {
			title: "Configurações de Filtro"
		},
		SampleWorkloadBalanceChart: {
			title: "Balanço de Carga de Trabalho"
		}
	}
};
var translation = {
	app: app,
	contentLoadingError: contentLoadingError,
	dashboard: dashboard,
	filter: filter,
	locationMap: locationMap,
	machineDiscontinuation: machineDiscontinuation,
	notifications: notifications,
	results: results,
	scrollToTop: scrollToTop,
	slider: slider,
	sorting: sorting,
	userAccount: userAccount,
	widget: widget,
	widgetRegistry: widgetRegistry
};

export { app, contentLoadingError, dashboard, translation as default, filter, locationMap, machineDiscontinuation, notifications, results, scrollToTop, slider, sorting, userAccount, widget, widgetRegistry };
